import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../../utils/utils";
import { getCustomerInvoices } from "../../../../../services/sales/customerService";
import Illustration from "../../../../../partials/content/Illustration";
import { Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import NumberFormat from "react-number-format";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import CustomPrintOutInvoice from "../../../../../partials/content/CustomPrintOutInvoice";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const CustomerInvoices = ({ history, customerID }) => {
  const { reload } = useGlobalData();
  const [invoices, setInvoices] = useState([]);
  const [invoice, setInvoice] = useState({});
  const [openInvoicePrint, setOpenInvoicePrint] = useState(false);
  const [fullyPaids, setFullyPaids] = useState(0);
  const [partiallyPaids, setPartiallyPaids] = useState(0);
  const [unpaids, setUnpaids] = useState(0);
  const [auth, setAuth] = useState({ create: false });
  useEffect(() => {
    getInvoicesData();
  }, [customerID, reload]);
  async function getInvoicesData() {
    const response = await getCustomerInvoices(customerID);
    const { data, auth } = response.data;
    setInvoices(data.invoices);
    setAuth(auth);
    const fullyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 3
    );
    const partiallyPaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 2
    );
    const unpaids = data.invoices.filter(
      (invoice) => invoice.paymentStatus === 1
    );
    setFullyPaids(fullyPaids.length);
    setPartiallyPaids(partiallyPaids.length);
    setUnpaids(unpaids.length);
  }

  const customerInvoiceDetailColumn = [
    {
      header: "Document Reference",
      field: "docRefDesc",
      type: "string",
    },
    {
      header: "Quotation ID",
      field: "quotationCode",
      type: "string",
    },
    {
      header: "Sales Order ID",
      field: "salesOrderCode",
      type: "string",
    },
    {
      header: "Delivery ID",
      field: "deliveryID",
      type: "string",
    },
    {
      header: "Direct Sales ID",
      field: "directSalesID",
      type: "string",
    },
    {
      header: "Cash Account",
      field: "cashAccountName",
      type: "string",
    },
    {
      header: "Deadline Date",
      field: "deadlineDate",
      type: "date",
    },
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "All Services Delivered",
      field: "servicesDel",
      type: "string",
    },
    {
      header: "Approval Status",
      field: "approvalStatusDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-success">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-check-circle kt-font-success" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">FULLY PAID</div>
                </div>
                <Badge variant="success">{fullyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">
                    PARTIALLY PAID
                  </div>
                </div>
                <Badge variant="warning">{partiallyPaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">UNPAID</div>
                </div>
                <Badge variant="danger">{unpaids}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {invoices.length ? (
        <React.Fragment>
          <CustomDataTable
            data={invoices}
            dataDetailColumns={customerInvoiceDetailColumn}
            onRefreshData={() => {
              getInvoicesData();
            }}
            columns={[
              {
                header: "A/R Invoice ID",
                field: "invoiceCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Invoice Date",
                field: "invoiceDate",
                body: (rowData) => formatDate(rowData.invoiceDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Goods Issue Status",
                field: "giStatusDesc",
                body: (rowData) => {
                  if (rowData.giStatus === 1) {
                    return (
                      <Badge variant="danger">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 2) {
                    return (
                      <Badge variant="warning">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.giStatusDesc}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Payment Status",
                field: "paymentStatus",
                body: (rowData) => {
                  if (rowData.paymentStatus === 1) {
                    return (
                      <Badge variant="danger">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.paymentStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.paymentStatus === 3) {
                    return (
                      <Badge variant="success">
                        {rowData.paymentStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.paymentStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Billing Amount",
                field: "billAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.billAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.view ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Account Receivable Invoice Detail">
                          <button
                            type="button"
                            onClick={() => {
                              history.push(
                                "/finance/invoice-detail/" + rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Account Receivable Invoice PrintOut">
                          <button
                            type="button"
                            onClick={() => {
                              setInvoice(rowData);
                              setOpenInvoicePrint(true);
                            }}
                            className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-print"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            guidance="You don't have any A/R Invoices for this customer yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/finance/invoices/AR");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To A/R Invoice
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openInvoicePrint}
        title="A/R Invoice PrintOut"
        onCloseDialog={() => {
          setOpenInvoicePrint(false);
        }}
        maxWIdth="lg"
      >
        <CustomPrintOutInvoice invoiceID={invoice.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenInvoicePrint(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
};

export default CustomerInvoices;
